import type { FeatureFlagConfig } from "@/shared/types/featureFlags"

import devFlags from "./dev.json"
import prodFlags from "./prod.json"
import qaFlags from "./qa.json"
import stagingFlags from "./staging.json"

const normalize = (value: unknown): string => {
  if (typeof value !== "string") return ""
  return value
    .trim()
    .replace(/^[`'"]+|[`'"]+$/g, "")
    .toLowerCase()
}

export const resolveConfig = (name: string): FeatureFlagConfig => {
  switch (name) {
    case "local":
    case "dev":
    case "develop":
    case "development":
      return devFlags as FeatureFlagConfig
    case "qa":
    case "qausa":
      return qaFlags as FeatureFlagConfig
    case "staging":
      return stagingFlags as FeatureFlagConfig
    case "prod":
    case "production":
      return prodFlags as FeatureFlagConfig
    default:
      return prodFlags as FeatureFlagConfig
  }
}

export const featureFlagConfig: FeatureFlagConfig = resolveConfig(
  normalize(import.meta.env.VITE_NODE_ENV),
)

export { normalize as normalizeEnvValue }
